import { FC, SVGAttributes } from "react";

const ChevronTextSmallLeft: FC<SVGAttributes<SVGSVGElement>> = (rest) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="black"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M9,12L5,8L9,4" />
  </svg>
);

export { ChevronTextSmallLeft };
